import * as React from 'react';
import {
    Grid
} from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';
import ClusterQuestionReviewComponent from './ClusterQuestionReviewComponent';
import SummaryComponent from '../responses/SummaryComponent';

export default class PageQuestionReviewComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            mnpTableData: {},
            grandTotalSupplySetOne: 0,
            grandTotalSupplySetTwo: 0
        };

        this.updateQuestion = this.updateQuestion.bind(this);
        this.updateQuestionVisibility = this.updateQuestionVisibility.bind(this);
        this.goToQuestion = this.goToQuestion.bind(this);
        this.addQuestionComment = this.addQuestionComment.bind(this);
        this.loaderVisibility = this.loaderVisibility.bind(this);
        
    }

    loaderVisibility(data: any) {
        this.props.loaderVisibility(data);
    }

    addQuestionComment(updateQuestionCommentData: any) {
        this.props.addQuestionComment(updateQuestionCommentData);
    }

    updateQuestion(updateQuestionData: any) {
        this.props.updateQuestion(updateQuestionData);
    }

    updateQuestionVisibility(updateQuestionVisibilityData: any) {
        this.props.updateQuestionVisibility(updateQuestionVisibilityData)
    }

    goToQuestion(data: any) {
        this.props.goToQuestion(data);
    }

    getQuestion(pageNumber: any, clusterIndex: any, questionIndex: any) {
        if (this.props.pages && this.props.pages.length > 0) {
            const pages = this.props.pages;
            const page: any = pages[pageNumber - 1];
            const clusters = page.page.question_clusters;
            const cluster = clusters[clusterIndex];
            const question = cluster.questions[questionIndex];

            return question;
        }
        else {
            return null;
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (this.props.pagePreview.page_number !== nextProps.pagePreview.page_number) {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        }

        if (nextProps.pagePreview.page_number && nextProps.moduleId && nextProps.pagePreview.page_number === 2 && nextProps.moduleId === 19) {
            const questionOne = this.getQuestion(nextProps.pagePreview.page_number - 1, 0, 0);
            const questionTwo = this.getQuestion(nextProps.pagePreview.page_number - 1, 0, 1);
            if (questionOne && questionTwo && questionOne.question_responses && questionTwo.question_responses && questionOne.question_responses.length > 0 && questionTwo.question_responses.length > 0) {
                const questionOneResponse = parseInt(questionOne.question_responses[0].value, 10);
                const questionTwoResponse = parseInt(questionTwo.question_responses[0].value, 10);
                const columnTwoData = isNaN(questionTwoResponse) ? 0 : questionTwoResponse * 2;
                const columnThreeData = questionOneResponse ? questionOneResponse * columnTwoData : 0;
                const columnFourData = parseInt(((5 / 100) * columnThreeData).toString(), 10);
                const columnFiveData = parseInt(((columnThreeData + columnFourData) / 30).toString(), 10);

                const mnpTableData = {
                    columnTwo: columnTwoData,
                    columnThree: columnThreeData,
                    columnFour: columnFourData,
                    columnFive: columnFiveData
                };

                this.setState({ mnpTableData });
            }
        }
    }

    getSetOneResponse(pageNumber: any, clusterInex: any, questionIndex: any) {
        const question = this.getQuestion(pageNumber, clusterInex, questionIndex);
        const responses = question.question_responses;
        return responses[0].value;
    }

    getSetTwoResponse(pageNumber: any, clusterInex: any, questionIndex: any) {
        const question = this.getQuestion(pageNumber, clusterInex, questionIndex);
        const responses = question.question_responses;
        return responses[1].value;
    }

    render() {
        return (
            <>
                {                 
                    this.props.pagePreview && this.props.pagePreview.title && this.props.clusters &&
                    <div className="pagePreviewWrapper">
                        <div className="pagePreviewTopSection">
                            <Grid container={true} spacing={24}>
                                <Grid item={true} xs={12}>
                                    <div className="pagePreviewTitle"><h3>{this.props.pagePreview.title.en}</h3></div>
                                    <div>
                                        <p>
                                            {ReactHtmlParser(this.props.pagePreview.page_description.en)}
                                        </p>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                        <div className="pagePreviewQueSection">
                            {
                                this.props.clusters.map((cluster: any, key: any) => {
                                    return (
                                        <>
                                            <ClusterQuestionReviewComponent
                                                pages={this.props.pages}
                                                pageNumber={this.props.pagePreview.page_number}
                                                pagePreview={this.props.pagePreview}
                                                updateQuestionVisibility={this.updateQuestionVisibility}
                                                updateQuestion={this.updateQuestion}
                                                addQuestionComment={this.addQuestionComment}
                                                clusterIndex={key}
                                                key={'cluster-component' + key}
                                                cluster={cluster}
                                                countryModuleSurveyMappingId={this.props.countryModuleSurveyMappingId}
                                                moduleId={this.props.moduleId}
                                                surveyStatus={this.props.surveyStatus}
                                                isResponsePage={this.props.isResponsePage}
                                                loaderVisibility={this.loaderVisibility}
                                                isOfflineMode={this.props.isOfflineMode}
                                                userId={this.props.userId}
                                                approveQuestion={this.props.approveQuestion}
                                            />
                                        </>
                                    )
                                })
                            }
                        </div>
                        {
                            this.props.pagePreview.issummary === true
                                ?
                                <SummaryComponent
                                    pagePreview={this.props.pagePreview}
                                    surveyStatus={this.props.surveyStatus}
                                    countryModuleSurveyMappingId={this.props.countryModuleSurveyMappingId}
                                    pages={this.props.pages}
                                    goToQuestion={this.goToQuestion}
                                    moduleId={this.props.moduleId}
                                    isOfflineMode={this.props.isOfflineMode}
                                    moduleName={this.props.moduleName}
                                    isQuestionReview={true}
                                />
                                : ''

                        }
                    </div>
                }
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/reviewquetions/PageQuestionReviewComponent.tsx